<template>
<div>
  <!-- <v-row>
    <v-col cols="11">
      <v-card-title class="titulopagina">REPORTE BITÁCORA</v-card-title>
    </v-col>
    <v-col cols="1">
      <v-alert class="amber accent-2 text-center" color="orange" outlined dense @click="abrirAyudas">
        <v-icon color="blue" large>help</v-icon>
      </v-alert>
    </v-col>
  </v-row> -->
  <modal-ayuda></modal-ayuda>
  <v-row>
    <v-card width="100%">
      <v-tabs
        background-color="teal darken-3"
        center-active
        dark
      >
        <v-tab  v-for="menu in puntos_medicion"
              :key="menu.id" @click="obtenerParametros(menu.id)">{{ menu.nombre_punto }}</v-tab>
      </v-tabs>
    </v-card>
  </v-row>

  <!-- nuevo panel -->
  <v-row>
      <v-expansion-panels>
        <v-expansion-panel>
          <v-expansion-panel-header>
            Buscar | Exportar a Excel
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row>
              <v-col cols="6">
                <v-card elevation="4" color="#c8e6c9" class="mx-auto">
                  <v-container>
                    <v-row dense>
                      <v-col cols="4">
                        <b>Exportar a Excel </b>
                      </v-col>
                      <v-col cols="8">
                        <v-radio-group class="ml-3" v-model="opcion_excel" row>
                          <v-radio label="Vista Actual" :value="1"></v-radio>
                          <v-radio label="Todo" :value="0"></v-radio>
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col cols="6">
                        <date-picker class="ml-2" v-model="rango_fechas" range format="DD-MM-YYYY" valueType="YYYY-MM-DD"></date-picker>
                      </v-col>
                      <v-col cols="4">
                        <v-select class="ml-4" v-model="conf_historica_id"
                                        :items="configuraciones_historicas" item-text="nombre"
                                        item-value="id" label="Seleccione Configuracion"
                                        color="blue darken-3" persistent-hint single-line dense
                                        ></v-select>
                      </v-col>
                      <v-col cols="3">
                        <v-btn small color="green darken-1" class="ml-2 mr-2" dark @click.stop="descargarExcel()">
                          <v-icon>description</v-icon> Excel
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card>
              </v-col>
              <v-col cols="1">
                <v-card elevation="4" color="#c8e6c9" class="mx-auto">
                  <v-container>
                    <v-row dense>
                        <b>Orden</b>
                        <v-radio-group class="ml-3" v-model="orden_fechas" row>
                          <v-radio label="ASC" :value="1" title="Ascendente"></v-radio>
                          <v-radio label="DESC" :value="0" title="Descendente"></v-radio>
                        </v-radio-group>
                    </v-row>
                  </v-container>
                </v-card> 
              </v-col>
              <v-col cols="5">
                <v-card elevation="4" color="#80d8ff" class="mx-auto">
                  <v-container>
                    <v-row dense>
                        <b>Mostrar Bitácora Fecha : </b>
                    </v-row>
                    <v-row dense>
                      <v-spacer></v-spacer>
                      <v-col cols="8">
                        <date-picker  class="ml-2" range-separator="|" v-model="fecha_picker" range format="DD-MM-YYYY" valueType="YYYY-MM-DD"></date-picker>
                      </v-col>
                      <v-col cols="4">
                        <v-btn small color="blue darken-2" class="ml-2 mr-2" dark @click="buscar_registros">Buscar</v-btn>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
  </v-row>
  <!-- nuevo panel -->
  
  <loader-compartido></loader-compartido>

  <v-row>
    <v-col style="padding-top:0px;">
            <tabla-registro-lectura-laboratorio class="ml-2 mr-2"></tabla-registro-lectura-laboratorio>
    </v-col>
  </v-row>
</div>
</template>

<script>
import {mapState,mapMutations} from 'vuex';
// import Loader_Lineal from '@/components/shared/Loader_Lineal.vue';
// import Loader_Lineal_Configurable from '../../components/shared/Loader_Lineal_Configurable.vue';
import Tabla_Registro_Lectura_Laboratorio from '../../components/shared/Tabla_Registro_Lectura_Laboratorio.vue';
import Loader_Compartido from '@/components/shared/Loader_Compartido.vue';

//datepicker vue2
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';

import ModalAyudas from '@/components/shared/ModalAyudas.vue';

export default {
    data:()=> ({
        roles_permitidos:['laboratorio','admin'],
        configuraciones_historicas:[],
        conf_historica_id:0,
        punto_medicion_actual:{},
        puntos_medicion:[],
        mostrar_fecha:false,
        mostrar_inicio:false,
        mostrar_termino:false,
        mostrarFechas: false,
        mostrarDescargarExcel: false,
        fecha_picker: new Date().toISOString().substr(0, 10),
        fecha_inicio: new Date().toISOString().substr(0, 10),
        fecha_termino: new Date().toISOString().substr(0, 10),
        rango_fechas:null,
        opcion_excel: 0,
        orden_fechas: 0,
        ajustes_tabla:{
            columnas_inicio:[
                {
                  titulo:'',
                  titulo_visible:true,
                  cabecera:'Fecha - Hora',
                  colspan:2,
                  subcolumnas:[
                    {cabecera:'Fecha',key:'fecha',visible:true,fixed:1,tipo:'texto'},
                    {cabecera:'Hora',key:'hora',visible:true,fixed:2,tipo:'texto'},
                  ]
                }
            ],
            columnas_final:[
                {
                  titulo:'',
                  titulo_visible:true,
                  cabecera:'Usuarios',
                  colspan:3,
                  subcolumnas:[
                    {cabecera:'Analista',key:'analista',visible:true,fixed:0,tipo:'select',opciones:[],texto:'name',seleccion:'id',label:'Analista'},
                    {cabecera:'Muestreador',key:'muestreador',visible:true,fixed:0,tipo:'select',opciones:[],texto:'name',seleccion:'id',label:'Muestreador'},
                    {cabecera:'J. Turno',key:'jefe_turno',visible:true,fixed:0,tipo:'select',opciones:[],texto:'name',seleccion:'id',label:'J. Turno'},
                  ]
                }
            ],
            tipos:[],
            acciones:[]
        },
        registros:[],
        analistas:[],
        muestreadores:[],
        jturnos:[]
    }),
    mounted() {
      this.comprobarPermisos();
        // this.cargarPuntosMedicion();
    },
    methods: {
      async cargarConfiguracionesHistoricas(){
          let url = `${this.base_url}configuraciones_historicas`
            await this.axios.get(url,this.headers).then((response)=>{
                //console.log('puntos de medicion',response.data.data)
                this.configuraciones_historicas = response.data.data
                this.configuraciones_historicas.unshift({
                  id:0,
                  nombre:'Actual'
                })
            }).catch((error)=>{
                console.log('error',error)
            })
        },
        abrirAyudas() {
          const jiji = [
            {   titulo:`Ayuda de Reporte Bitácora`,    tipo:`titulo`},
            {   tipo:`label`,   texto:`En esta pantalla se muestran los maxisacos de cada lote según los análisis que se obtuvieran.`},
            {   tipo:`label`,   texto:`- En la barra de desplazamiento de arriba se selecciona el punto de medición de la bitácora.`},
            {   tipo:`label`,   texto:`- En la tabla inferior se muestra cada maxisaco, la fecha y hora de producción, observaciones, código, lote, número de maxisaco y los resultados de los análisis por cada parámetro que corresponda.`},
            {   tipo:`label`,   texto:`- Pulsando en el texto "Buscar | Exportar a Excel", se abre un menú de opciones para la exportación en formato Excel de la bitácora en recuadro de color verde, en el que se puede indicar las fecha que se quiere exportar o la hoja actual y el orden en que se quiere que se muestren los registros. Con el botón "Excel" se realiza la exportación.`},
            {   tipo:`label`,   texto:`- El recuadro celeste (luego de mostrar opciones) sirve para buscar la bitácora según la fecha indicada. Con el botón "buscar" se realiza esta búsqueda y finalmente se muestra en la tabla de abajo la bitácora de esa fecha indicada.`},
          ];
          
          Event.$emit('mostrar_alert',jiji);
        },
        async comprobarPermisos(){
          let acceder = false;
          await this.roles_permitidos.forEach(async(rol) => {
            await this.roles.forEach(rol_u => {
              if(rol_u == rol){
                acceder = true;
              }
            });
          });
          if(!acceder){
            this.$router.push('/');
          }else{
            this.cargarPuntosMedicion();
            this.cargarConfiguracionesHistoricas();
          }
        },
        async cargarPuntosMedicion(){
            //this.mostrarLoading('Cargando Puntos de Medición...')
            this.mostrarLoading({titulo:'Cargando Puntos de Medición...',color:'green'})

            let url = `${this.base_url}punto_medicion`
            await this.axios.get(url,this.headers).then((response)=>{
                // console.log('puntos de medicion',response.data.data)
                this.puntos_medicion = response.data.data
                this.puntos_medicion.sort(function(a, b){return a.orden - b.orden});
                this.ocultarLoading()
                this.obtenerParametros(this.puntos_medicion[0].id)
            }).catch((error)=>{
                console.log('error',error)
                this.ocultarLoading()
            })
        },
        async obtenerParametros(id){
          //this.mostrarLoading('Cargando...');
          this.mostrarLoading({titulo:'Cargando...',color:'green'})

          this.restablecerAjustes();

          let pm = this.puntos_medicion.filter((punto)=>{
            return punto.id == id;
          });
          this.punto_medicion_actual = pm[0];
          // console.log('punto de medicion actual',this.punto_medicion_actual);
          let punto_medicion_id = pm[0].id;
          
          //agrega las columnas adicionales que son unicas dependiendo del tipo de punto de medicion (linea,jumbo)
          await this.agregarColumnasAdicionales(pm[0].tipo_punto);
          //agrega los usuarios analistas, muestreadores y jefes de turno
        //   await this.cargarUsuarios();
          //carga los ultimos 20 registros del punto de medicion seleccionado
          await this.cargarUltimosRegistros(punto_medicion_id);

            // console.log('punto_mediciones_id',id);
            //peticion que carga los parametros de un punto de medicion
            let url = `${this.base_url}punto_medicion/parametros/${id}`;
          //this.mostrarLoading('Generando Tabla...');
          this.mostrarLoading({titulo:'Generando Tabla...',color:'green'})

          await this.axios.get(url,this.headers).then((response)=>{
                
                let parametros = response.data.data;
                //realiza una busqueda de los tipos de equipo que sean distintos
                let tipos = this.buscarTiposEquiposDistintos(parametros);
                // console.log('tipos de equipo distintos',tipos);

                //busca todos los equipos que sean distintos (ademas carga los parametros del equipo)
                let equipos_distintos = this.buscarEquiposDistintos(parametros);
                // console.log('equipos_distintos',equipos_distintos);

                // asigna los equipos a los tipos de equipo
                let ajustes_finales = this.asignarEquiposATiposDeEquipo(tipos,equipos_distintos);
                //console.log('ajustes_finales',ajustes_finales);

                //se realiza el seteo de los ajustes para la tabla_registro
                this.ajustes_tabla.tipos = ajustes_finales;
                //this.ajustes_tabla.equipos = this.buscarEquiposDistintos(indicadores)
                //console.log('ajustes_tabla',this.ajustes_tabla);
                this.$emit('crear_tabla',this.ajustes_tabla,this.registros,this.punto_medicion_actual);
                this.ocultarLoading();
            }).catch((error)=>{
                console.log('error',error);
                this.ocultarLoading();
            })
        },

        async cargarUltimosRegistros(punto_medicion_id){
          //this.mostrarLoading('Cargando Últimos Registros...');
          this.mostrarLoading({titulo:'Cargando Últimos Registros...',color:'green'});
          let inicio = null;
          let termino = null;
          if(this.fecha_picker){
            inicio = ((this.fecha_picker[0] != null) && (this.fecha_picker[0].length > 6 )) ? this.fecha_picker[0] : null;
            termino = ((this.fecha_picker[1] != null) && (this.fecha_picker[1].length > 6 )) ? this.fecha_picker[1] : null;
          }
          console.log('inicio',inicio,'termino',termino);

          let url = `${this.base_url}punto_medicion/resultados/${punto_medicion_id}/${inicio}/${termino}`;
            await this.axios.get(url,this.headers).then((response)=>{
              // console.log('ultimos registros laboratorio',response.data.data);
              this.registros = response.data.data;
              this.ocultarLoading();
            }).catch((error)=>{
              console.log('error',error);
              this.ocultarLoading();
            })
        },

        asignarEquiposATiposDeEquipo(tipos,equipos_distintos){
          tipos.forEach(tipo => {
            let colspan = 0;
            equipos_distintos.forEach(equipo => {
              if(tipo.tipo_equipo_id == equipo.tipo_equipo_id){
                tipo.equipos.push(equipo)
                colspan+=equipo.colspan;
              }
            });
            //ordenando los equipos de cada tipo de equipo
            tipo.equipos = tipo.equipos.sort(function(a, b){return a.orden - b.orden});
            //console.log('equipos_ordenados',tipo.equipos);
            tipo.colspan = colspan;
          });
          return tipos;
        },

        buscarTiposEquiposDistintos(parametros){
          let map = new Map();
          let tipos = [];
          parametros.forEach(par=>{
            if(!map.has(par.equipos_procesos.tipo_equipos_id)){
                map.set(par.equipos_procesos.tipo_equipos_id,true);
                tipos.push({
                  tipo_equipo_id:par.equipos_procesos.tipo_equipos_id,
                  tipo_equipo:par.equipos_procesos.tipo_equipo.tipo_equipo,
                  visible:true,
                  equipos:[]
                });
            }
          });

          return tipos;
        },

        buscarEquiposDeTipoDeEquipo(parametros,tipo_equipo_id){
          let equipos = [];
          let equipos_distintos = this.buscarTiposEquiposDistintos(parametros);
          equipos_distintos.forEach(equipo => {
            if(equipo.tipo_equipo_id==tipo_equipo_id){
              equipos.push(equipo);
            }
          });
          
          return equipos;
        },
        
        buscarEquiposDistintos(array){
          // console.log('parametros',array);
          //array corresponde a los parametros
            let map = new Map();
            let equipos = [];
            array.forEach(item => {
                //llenando los parametros
                //this.ajustes_tabla.indicadores.push({id:item.id,nombre_indicador:item.indicadores.nombre_indicador,visible:true,fixed:0})
                //buscando los equipos distintos
                if(!map.has(item.equipos_procesos_id)){
                        map.set(item.equipos_procesos_id, true);    // set any value to Map
                        
                        //buscando los parametros del equipo
                        let parametros = [];
                        array.forEach(parametro => {
                          if(parametro.equipos_procesos_id==item.equipos_procesos_id){
                            parametros.push({
                              id:parametro.id,
                              nombre_parametro:parametro.parametros.nombre_parametro,
                              nombre_equipo:parametro.equipos_procesos.nombre_equipo,
                              equipos_procesos_id:parametro.equipos_procesos_id,
                              unidad_medida:parametro.unidad_medida.nombre_corto,
                              orden:parametro.orden,
                              visible:true,
                              formula:parametro.formulas,
                              valor_minimo:parametro.valor_minimo,
                              valor_maximo:parametro.valor_maximo,
                              alarma_1:parametro.alarma01,
                              signo_1:parametro.signo01,
                              alarma_2:parametro.alarma02,
                              signo_2:parametro.signo02,
                              optimo_minimo:parametro.optimo_minimo,
                              optimo_maximo:parametro.optimo_maximo,
                              tipo:parametro.parametros.tipo,
                              opciones:parametro.parametros.opciones_activas,
                              fixed:0});
                          }
                        });

                        //ordenando los parametros
                        parametros = parametros.sort(function(a, b){return a.orden - b.orden});

                        //agregando el equipo con sus parametros
                        equipos.push({
                            equipos_procesos_id:item.equipos_procesos_id,
                            tipo_equipo_id:item.equipos_procesos.tipo_equipos_id,
                            parametros:parametros,
                            cabecera:item.equipos_procesos.nombre_equipo,
                            colspan:this.calcularColspan(item.equipos_procesos_id,array),
                            orden:item.equipos_procesos.orden});
                }
            })
            return equipos;
        },
        calcularColspan(id_equipo,array){
            let colspan = 0;
            array.forEach(item => {
                if(item.equipos_procesos_id == id_equipo){
                    colspan++;
                }
            });
            return colspan;
        },

        restablecerAjustes(){
          this.ajustes_tabla = {
              columnas_inicio:[
                {
                  titulo:'',
                  titulo_visible:true,
                  cabecera:'Fecha - Hora',
                  colspan:2,
                  subcolumnas:[
                    {cabecera:'Fecha',key:'fecha',visible:true,fixed:1,tipo:'texto'},
                    {cabecera:'Hora',key:'hora',visible:true,fixed:2,tipo:'texto'},
                  ]
                }
              ],
              columnas_final:[
                  {
                    titulo:'',
                    titulo_visible:true,
                    cabecera:'Responsable',
                    colspan:3,
                    subcolumnas:[
                      {cabecera:'Analista',key:'analista',visible:true,fixed:0,tipo:'select',opciones:[],texto:'name',seleccion:'id',label:'Analista'},
                      {cabecera:'Muestreador',key:'muestreador',visible:true,fixed:0,tipo:'select',opciones:[],texto:'name',seleccion:'id',label:'Muestreador'},
                      {cabecera:'J. Turno',key:'jefe_turno',visible:true,fixed:0,tipo:'select',opciones:[],texto:'name',seleccion:'id',label:'J. Turno'},
                    ]
                  }
              ],
              tipos:[],
              acciones:[]
          };
          this.registros = [];
        },

        async agregarColumnasAdicionales(tipo_punto){
          if(tipo_punto == 'linea'){
            
            this.ajustes_tabla.columnas_inicio.push({
                  titulo:'',
                  titulo_visible:true,
                  cabecera:'Materia Prima',
                  colspan:1,
                  subcolumnas:[
                    {cabecera:'MP',key:'tipo_mps_id',visible:true,solo_lectura:false,fixed:0,tipo:'select',opciones:[],texto:'tipo_materia_prima',seleccion:'id',label:'Materia Prima'},
                  ]
            });
            // await this.cargarMateriasPrimas();
          }else if(tipo_punto == 'jumbo'){
            /*this.ajustes_tabla.columnas_inicio.push({
              titulo:'',
              titulo_visible:true,
              cabecera:'C.Planta',
              colspan:1,
              subcolumnas:[
                {cabecera:'C.Planta',key:'control_planta',visible:true,solo_lectura:true,fixed:0,tipo:'texto'}
              ]
            });*/
            this.ajustes_tabla.columnas_inicio.push({
              titulo:'',
              titulo_visible:true,
              cabecera:'C.Planta',
              colspan:1,
              subcolumnas:[
                {cabecera:'C.Planta',key:'control_planta',visible:true,solo_lectura:true,fixed:0,tipo:'texto'}
              ]
            });
            this.ajustes_tabla.columnas_inicio.push({
              titulo:'',
              titulo_visible:true,
              cabecera:'Lote',
              colspan:1,
              subcolumnas:[
                {cabecera:'N° Lote',key:'nombre_lote',visible:true,fixed:0,tipo:'label'}
              ]
            });
            this.ajustes_tabla.columnas_inicio.push({
              titulo:'',
              titulo_visible:true,
              cabecera:'Maxisaco',
              colspan:1,
              subcolumnas:[
                {cabecera:'Maxisaco N°',key:'nro_jumbo',visible:true,fixed:0,tipo:'label'}
              ]
            });
            // console.log(this.ajustes_tabla.columnas_inicio);
          }else if(this.punto_medicion_actual.id == 8){
            /**punto de medicion lotes completos */
            this.ajustes_tabla.columnas_inicio.push({
              titulo:'',
              titulo_visible:true,
              cabecera:'',
              colspan:1,
              subcolumnas:[
                {cabecera:'Lote',key:'lotes_id',visible:true,solo_lectura:false,fixed:0,tipo:'select',opciones:[],texto:'nombre_lote',seleccion:'id',label:'Seleccione Lote'},
              ]
            });

            // await this.cargarLotes();
          }
        },

        async crearExcel(){
          let fecha_inicio = this.fecha_inicio != ''? this.moment(this.fecha_inicio).format('YYYY-MM-DD'):'';
          let fecha_termino = this.fecha_termino != ''? this.moment(this.fecha_termino).format('YYYY-MM-DD'):'';
          let punto_medicion = this.punto_medicion_actual.id;
          if(this.opcion_excel == 0){
            punto_medicion = 0;
          }
          let url = `${this.base_url}resultados/bitacora/${fecha_inicio}/${fecha_termino}/${punto_medicion}`;
          await this.axios.get(url, this.headers).then((response)=>{
            // console.log(response.data.data);
            window.location.href = response.data.data;
          }).catch((error)=>{
            console.log('error', error);
          });
        },

        async descargarExcel(){
          // console.log('rango fechas',this.rango_fechas);
          if(this.rango_fechas){
            let inicio = this.rango_fechas[0];
            let termino = this.rango_fechas[1];
            let orden = this.orden_fechas;
            let p_m = this.opcion_excel == 0? 0 : this.punto_medicion_actual.id;
            let url = `${this.base_url}resultados/bitacora/${inicio}/${termino}/${p_m}/${orden}/${this.conf_historica_id}`;
            this.mostrarLoading({titulo:'Generando Información...',color:'green'})

            await this.axios.get(url, this.headers).then((response)=>{
              // console.log(response.data.data);
              this.ocultarLoading();
              window.location.href = response.data.data;
            }).catch((error)=>{
              console.log('error', error);
              this.mostrarLoading({titulo:'Error...' + error,color:'red'})
            });
          }
        },

        async buscar_registros(){
          console.log("fecha_picker",this.fecha_picker)
          if(this.fecha_picker){
            let inicio = this.fecha_picker[0];
            let termino = this.fecha_picker[1];
            let orden = this.orden_fechas;
            let conf = {
              color:'#00796B'
            }
            this.mostrarLoading({titulo:'Cargando Información... si la búsqueda contiene muchos días demorará más ...',color:'green'})
            this.$emit('iniciar',conf);
            let url = `${this.base_url}punto_medicion/${this.punto_medicion_actual.id}/resultados/fecha/${inicio}/${termino}/${orden}`;
            await this.axios.get(url,this.headers).then((response)=>{
              this.registros = response.data.data;
              this.$emit('crear_tabla',this.ajustes_tabla,this.registros,this.punto_medicion_actual);
              this.$emit('terminar');
              this.ocultarLoading();
            }).catch((error)=>{
              console.log('error',error);
              this.mostrarLoading({titulo:'Error...' + error,color:'red'})
            });
          }
        },

        ...mapMutations(['mostrarLoading','ocultarLoading'])
    },
    computed: {
        ...mapState({
          base_url:state => state.base_url,
          headers:state => state.headers,
          roles: state => state.roles_prod
        }),
        mostrarBotonAgregar(){
            if(this.ajustes_tabla.tipos.length>0){
              return false;
            }else{
              return true;
            }
        },

        mostrarBotonExcel(){
            if(this.ajustes_tabla.tipos.length>0){
              return false;
            }else{
              return true;
            }
        },

        fecha_formateada () {
          //return this.fecha_picker ? this.moment(this.fecha_picker).format('DD-MM-YYYY') : '';
        }
    },
    components:{
        'tabla-registro-lectura-laboratorio':Tabla_Registro_Lectura_Laboratorio,
        'loader-compartido':Loader_Compartido,
        DatePicker,
        'modal-ayuda': ModalAyudas,
    }
  }
</script>